import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import React from 'react';
import CriticsList from './CriticsItemList';

const Critics = () => {
  const breadcrumbs = [
    { label: 'مدیریت محتوی', link: '/content' },
    { label: 'مدیریت نقد کوتاه', isActive: true },
  ];
  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={'مدیریت نقد کوتاه'}>
      <CriticsList />
    </PageContainer>
  );
};

export default Critics;
